import { getDefaultLanguage } from './services/translate/translateService';
import defaultSkin from './services/template/defaultSkin';

export const LOCAL_STORAGE = {
  URL_TO_LOGOUT_CALLBACK: 'urlToLogoutCallback',
  LIS_OUTCOME_SERVICE_URL: 'lis_outcome_service_url',
  LIS_RESULT_SOURCED_ID: 'lis_result_sourcedid',
  LIS_RESOURCE_ID: 'lis_resource_id',
  LIS_USER_IDS: 'userIds',
  THEME_SETTINGS: 'themeSettings',
  SMART_AUTH_TOKEN: 'smartAuthToken',
  SMART_REFRESH_TOKEN: 'smartRefreshToken',
  SMART_GUEST_TOKEN: 'smartGuestToken',
  SMART_GUEST_SESSION: 'smartGuestSession',
  SMART_GUEST_PROFILE: 'smartGuestProfile',
  CONFIGURATION: 'configuration',
  SMART_AUTH_LANGUAGE: 'smartAuthLanguage',
  SMART_AUTH_USERID: 'smartAuthUserId',
  CMI5_ETAGS: 'smartCmi5etags',
  USER_DATA: 'userData',
  EXPIRED: 'tokenExpired',
  SMART_AUTH_METHOD: 'smartAuthMethod',
  GOOGLE_TOKEN_RESPONSE: 'googleTokenResponse'
};

/**
 * TOKEN STORAGE HANDLER
 */
export let authTokenStorageHandler = authToken => {
  if (!authToken || !authToken.length) {
    setTokenToStorage('');
  } else {
    setTokenToStorage(authToken);
  }
};

export let refreshTokenStorageHandler = refreshToken => {
  if (!refreshToken || !refreshToken.length) {
    setRefreshTokenToStorage('');
  } else {
    setRefreshTokenToStorage(refreshToken);
  }
};

export let getTokenFromStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.SMART_AUTH_TOKEN);
};

const setTokenToStorage = authToken => {
  return window.localStorage.setItem(LOCAL_STORAGE.SMART_AUTH_TOKEN, authToken);
};

export let getRefreshTokenFromStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.SMART_REFRESH_TOKEN);
};

const setRefreshTokenToStorage = refreshToken => {
  return window.localStorage.setItem(LOCAL_STORAGE.SMART_REFRESH_TOKEN, refreshToken);
};

export const getAuthenticationMethod = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.SMART_AUTH_METHOD);
};

/**
 * GUEST TOKEN STORAGE HANDLER
 */
export let guestTokenStorageHandler = guestToken => {
  if (!guestToken || !guestToken.length) {
    window.localStorage.removeItem(LOCAL_STORAGE.SMART_GUEST_TOKEN);
  } else {
    window.localStorage.setItem(LOCAL_STORAGE.SMART_GUEST_TOKEN, guestToken);
  }
};

export let getGuestTokenFromStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.SMART_GUEST_TOKEN);
};

export let removeGuestTokenFromStorage = () => {
  window.localStorage.removeItem(LOCAL_STORAGE.SMART_GUEST_TOKEN);
};

export let setGuestSessionInStorage = guestSession => {
  if (!guestSession) {
    window.localStorage.removeItem(LOCAL_STORAGE.SMART_GUEST_SESSION);
  } else {
    window.localStorage.setItem(LOCAL_STORAGE.SMART_GUEST_SESSION, JSON.stringify(guestSession));
  }
};

export let getGuestSessionFromStorage = () => {
  const guestSession = window.localStorage.getItem(LOCAL_STORAGE.SMART_GUEST_SESSION);
  return guestSession ? JSON.parse(guestSession) : null;
};

export let removeGuestSessionFromStorage = () => {
  window.localStorage.removeItem(LOCAL_STORAGE.SMART_GUEST_SESSION);
};

// Perfil (nombre/email) del invitado: independiente del token/sesión a propósito, para que
// sobreviva a un "Salir" o a la caducidad del token y quede precargado en visitas futuras.
export let setGuestProfileInStorage = ({ name, email }) => {
  window.localStorage.setItem(LOCAL_STORAGE.SMART_GUEST_PROFILE, JSON.stringify({ name, email }));
};

export let getGuestProfileFromStorage = () => {
  const raw = window.localStorage.getItem(LOCAL_STORAGE.SMART_GUEST_PROFILE);
  if (!raw) {
    return { name: '', email: '' };
  }
  try {
    const { name, email } = JSON.parse(raw);
    return { name: name || '', email: email || '' };
  } catch (e) {
    return { name: '', email: '' };
  }
};

export const setAuthenticationMethod = authenticationMethod => {
  return window.localStorage.setItem(LOCAL_STORAGE.SMART_AUTH_METHOD, authenticationMethod);
};

export const removeAuthenticationMethod = () => {
  return window.localStorage.removeItem(LOCAL_STORAGE.SMART_AUTH_METHOD);
};

/**
 * CONFIGURATION STORAGE HANDLER
 */

export let getTokenExpired = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.EXPIRED);
};

export let setTokenExpired = expired => {
  return window.localStorage.setItem(LOCAL_STORAGE.EXPIRED, expired);
};

/**
 * TOKEN REMOVE HANDLER
 */

export let removeAuthTokenFromStorage = () => {
  return window.localStorage.removeItem(LOCAL_STORAGE.SMART_AUTH_TOKEN);
};

export let removeRefreshTokenFromStorage = () => {
  return window.localStorage.removeItem(LOCAL_STORAGE.SMART_REFRESH_TOKEN);
};

export const removeLtiParamsFromStorage = () => {
  window.localStorage.removeItem(LOCAL_STORAGE.LIS_OUTCOME_SERVICE_URL);
  window.localStorage.removeItem(LOCAL_STORAGE.LIS_RESULT_SOURCED_ID);
  // Incluir lis_resource_id para no conservar el activityId de Moodle tras salir del contexto LTI.
  window.localStorage.removeItem(LOCAL_STORAGE.LIS_RESOURCE_ID);
  window.localStorage.removeItem(LOCAL_STORAGE.LIS_USER_IDS);
};

/*export let removeDownloadFromStorage = (item) => {
  return window.localStorage.removeItem(item);
};*/

/**
 * CONFIGURATION STORAGE HANDLER
 */

export let getConfigurationFromStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.CONFIGURATION);
};

export let setConfigurationFromStorage = config => {
  return window.localStorage.setItem(LOCAL_STORAGE.CONFIGURATION, config);
};

/**
 * SAVE_BOOKS STORAGE HANDLER
 */
export let removeBooksFromStorage = () => {
  const cancellsStore = Object.keys(window.localStorage).filter(attribute => attribute.indexOf('cancel') > -1);
  cancellsStore.map(book => window.localStorage.removeItem(book));
  const booksStore = Object.keys(window.localStorage).filter(attribute => attribute.indexOf('saveBook_') > -1);
  booksStore.map(book => window.localStorage.removeItem(book));
};

/**
 * USER_DATA STORAGE HANDLER
 */
export let userDataStorageHandler = userData => {
  if (userData && userData._id && userData.role) {
    window.localStorage.setItem(LOCAL_STORAGE.USER_DATA, userData);
  }
};

export let getUserDataFromStorage = () => {
  return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE.USER_DATA));
};

export let setUserDataFromStorage = userData => {
  return window.localStorage.setItem(LOCAL_STORAGE.USER_DATA, userData);
};

/**
 * LANGUAGE STORAGE HANDLER
 */
export let languageStorageHandler = language => {
  if (!language || !language.length) {
    setLanguageFromStorage(getDefaultLanguage());
  } else {
    setLanguageFromStorage(language);
  }
};

export let getLanguageFromStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.SMART_AUTH_LANGUAGE);
};

const setLanguageFromStorage = language => {
  return window.localStorage.setItem(LOCAL_STORAGE.SMART_AUTH_LANGUAGE, language);
};

/**
 * USER ID STORAGE HANDLER
 */
export let userIdStorageHandler = userId => {
  if (!userId || !userId.length) {
    window.localStorage.setItem(LOCAL_STORAGE.SMART_AUTH_USERID, '');
  } else {
    window.localStorage.setItem(LOCAL_STORAGE.SMART_AUTH_USERID, userId);
  }
};

/**
 * THEME SETTINGS STORAGE HANDLER
 */
export let getSkinFromStorageOrDefault = () => {
  let skin = window.localStorage.getItem(LOCAL_STORAGE.THEME_SETTINGS);
  if (!skin || skin === 'undefined') return defaultSkin;

  return JSON.parse(skin);
};

export let setSkinInStorage = themeSettings => {
  return window.localStorage.setItem(LOCAL_STORAGE.THEME_SETTINGS, JSON.stringify(themeSettings));
};

export let setUrlToLogoutCallbackInStorage = urlToLogoutCallback => {
  window.localStorage.setItem(LOCAL_STORAGE.URL_TO_LOGOUT_CALLBACK, urlToLogoutCallback);
};

export let getUrlToLogoutCallbackInStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE.URL_TO_LOGOUT_CALLBACK);
};

/**
 * CMI5 ETAGS STORAGE FUNCTIONS
 */
export let getCmi5etagsInStorage = () => {
  return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE.CMI5_ETAGS));
};
